import { useCallback, useEffect, useLayoutEffect, useState } from 'react';

const useDropShadow = (ref) => {
  const [dropShadow, setDropShadow] = useState(false);
  const handleScroll = useCallback(() => {
    if (!ref.current) return;

    const { scrollTop, scrollHeight, clientHeight } = ref.current;

    if (Math.ceil(clientHeight + scrollTop) === Math.ceil(scrollHeight)) {
      setDropShadow(false);
    } else setDropShadow(true);
  }, [dropShadow, setDropShadow, ref.current]);

  useLayoutEffect(() => {
    if (ref.current) {
      handleScroll();

      ref.current.addEventListener('scroll', handleScroll);
    }

    return () => {
      if (ref.current) {
        ref.current.removeEventListener('scroll', handleScroll);
      }
    };
  }, []);

  useEffect(() => {
    const resizeObserver = new ResizeObserver(() => handleScroll());

    if (ref.current) {
      resizeObserver.observe(ref.current);
    }

    return () => {
      if (ref.current) {
        resizeObserver.unobserve(ref.current);
      }
      resizeObserver.disconnect();
    };
  }, []);

  return { dropShadow };
};

export { useDropShadow };
